// extracted by mini-css-extract-plugin
export default {"wrapper":"Drawer_wrapper__Ylup9","mainDrawer":"Drawer_mainDrawer__TbgUg"};